export const RewardsLink = () => null;
